import DashboardViewDetailsListItems from "./dashboardViewDetailsListItems";
export default DashboardViewDetailsListItems;
